import { useMediaQuery } from "usehooks-ts";
import { Button, Container, Paper, SimpleGrid, Stack } from "@mantine/core";
import Link from "next/link";
import { purfifyHTML } from "@/services/services";
import parse from "html-react-parser";

function GridHero(props) {
  const isMobile = useMediaQuery("(max-width: 1024px)");
  const colNum = isMobile ? 1 : Math.min(props.colNum, 4);
  const colorNum = props.colors.length;

  // components
  const cardJSX = ({
    key,
    bg,
    title,
    description,
    showButton,
    buttonLabel,
    buttonUrl,
    buttonVariant,
    buttonColor,
    image,
  }) => {
    return (
      <Paper key={key} bg={bg} radius={25} px={40} py={30}>
        <Stack align="center" justify={"space-between"} h={"100%"} spacing={40}>
          <Stack align="center">
            {image && parse(purfifyHTML(image))}
            {title && parse(purfifyHTML(title))}
            {description && parse(purfifyHTML(description))}
          </Stack>
          {showButton && (
            <Link href={buttonUrl ?? "#"}>
              <Button
                size="xl"
                radius="xl"
                variant={buttonVariant}
                c={buttonColor}
              >
                {buttonLabel && parse(purfifyHTML(buttonLabel))}
              </Button>
            </Link>
          )}
        </Stack>
      </Paper>
    );
  };

  return (
    <Container p={{ base: 48, sm: 64 }} miw={"100%"}>
      <Stack align="center" spacing={40}>
        {parse(purfifyHTML(props.title))}
        <SimpleGrid cols={colNum} spacing={"xl"}>
          {props.data.map((card, index) =>
            cardJSX({
              key: index,
              bg: props.colors[index % colorNum],
              title: card.title,
              description: card.description,
              showButton: card.showButton,
              buttonLabel: card.buttonLabel,
              buttonUrl: card.buttonUrl,
              buttonVariant: card.buttonVariant ?? "white",
              buttonColor: card.buttonColor ?? props.colors[index % colorNum],
              image: card.image,
            })
          )}
        </SimpleGrid>
      </Stack>
    </Container>
  );
}

export default GridHero;
